<div class="flex h-auto w-auto items-center justify-center rounded-[15px] border border-solid border-white language-switcher cursor-pointer"
    (click)="fireToggleLanguage()">
    <button type="button" [class.active]="isEn">
        <span class="whitespace-nowrap">EN</span>
    </button>
    <button type="button" [class.active]="!isEn">
        <span class="mt-[-5px]">ع</span>
    </button>
</div>